export default "__VITE_ASSET__iPSm6efB__"